<template>
  <div class="body">
    <template v-if="address">
      <MyCollectionTabs :active-tab="activeTab" @CHOOSE_TAB="chooseTab" />
      <Assets v-if="activeTab === 'assets'" />
      <MarketCollection v-if="activeTab === 'on-market'" />
      <Favorited v-if="activeTab === 'favorited'" />
    </template>
    <template v-else>
      <div class="connect-message">
        Please connect your wallet
      </div>
    </template>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import MyCollectionTabs from '@/components/MyCollection/MyCollectionTabs.vue';
import Assets from '@/views/MyCollection/Assets.vue';
import MarketCollection from '@/views/MyCollection/Market.vue';
import Favorited from '@/views/MyCollection/Favorited.vue';

export default {
  components: { MyCollectionTabs, Assets, MarketCollection, Favorited },
  data() {
    return {
      activeTab: 'assets'
    };
  },
  computed: {
    ...mapState('auth', ['address'])
  },
  watch: {
    $route() {
      const meta = this.$route.meta;
      this.activeTab = meta.tab || 'assets';
    }
  },
  created() {
    const meta = this.$route.meta;
    this.activeTab = meta.tab || 'assets';
  },
  methods: {
    chooseTab(activeTab) {
      if (activeTab !== this.activeTab) {
        this.$router.push({ name: `my-collection/${activeTab}` });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.body {
  margin: 40px 0;
  min-height: 50vh;
  .connect-message {
    font-family: Inter-Regular;
    font-size: 20px;
    text-align: center;
    font-style: italic;
  }
}
</style>
